/* Label Privé — parcours d'estimation. Configuration injectée par la section via window.LPE_CFG. */
(function () {
  var CFG = window.LPE_CFG || {};
  var root = document.querySelector('[data-lpe]');
  if (!root) return;

  var ACC = {
    luxe: ['Boîte d’origine', 'Dustbag / housse', 'Facture ou ticket', 'Cadenas et clés', 'Bandoulière', 'Pochette amovible'],
    montres: ['Boîte d’origine', 'Papiers / certificat', 'Facture ou ticket', 'Maillons supplémentaires', 'Bracelet de rechange', 'Carnet de révision']
  };
  var SHOTS = {
    luxe: ['Face avant entière, sac posé debout', 'Dos et dessous', 'Les quatre coins, en gros plan', 'Poignées et bandoulière', 'Parties métalliques : fermoir, zip, pieds', 'Intérieur, doublure et poches', 'Étiquette ou tampon du numéro de série'],
    montres: ['Cadran de face, sans reflet', 'Profil du boîtier des deux côtés', 'Dos du boîtier et gravures', 'Bracelet entier et boucle', 'Verre en lumière rasante', 'Papiers, boîte et facture s’ils existent']
  };
  var TYPE = { luxe: 'Sac ou accessoire de luxe', montres: 'Montre de luxe' };
  var BONUS = { 'Facture ou ticket': 3, 'Papiers / certificat': 4, 'Boîte d’origine': 2, 'Dustbag / housse': 1, 'Cadenas et clés': 1, 'Maillons supplémentaires': 1, 'Bracelet de rechange': 1, 'Carnet de révision': 2, 'Bandoulière': 1, 'Pochette amovible': 1 };
  var GRADE = { S: 0, A: 0, B: 1, C: 2, D: 3 };
  var GRADE_LABEL = { S: 'Comme neuf (S)', A: 'Excellent état (A)', B: 'Bon état (B)', C: 'Usure visible (C)', D: 'À restaurer (D)' };

  var q = function (s) { return root.querySelector(s); };
  var form = q('[data-lpe-form]');
  var err = q('[data-lpe-error]');
  var next = q('[data-lpe-next]');
  var card = q('[data-lpe-card]');
  var section = q('[data-lpe-section]');
  var bar = q('[data-lpe-bar]');
  var fillEl = q('[data-lpe-fill]');
  var count = q('[data-lpe-count]');
  var recap = q('[data-lpe-recap]');
  var cat = q('[data-lpe-cat]');
  var brand = q('[data-lpe-brand]');
  var model = q('[data-lpe-model]');
  var version = q('[data-lpe-version]');
  var start = q('[data-lpe-start]');
  var note = q('[data-lpe-note]');
  var freeBtn = q('[data-lpe-free]');
  var freeWrap = q('[data-lpe-free-wrap]');
  var matWrap = q('[data-lpe-mat-wrap]');
  var matSel = q('[data-lpe-mat]');
  var colWrap = q('[data-lpe-col-wrap]');
  var colSel = q('[data-lpe-col]');
  var refWrap = q('[data-lpe-ref-wrap]');
  var accWrap = q('[data-lpe-acc]');
  var shotsUl = q('[data-lpe-shots]');
  var drop = q('[data-lpe-drop]');
  var fileInp = q('[data-lpe-file]');
  var thumbs = q('[data-lpe-thumbs]');
  var photoCount = q('[data-lpe-photo-count]');
  var resBox = q('[data-lpe-res]');

  var TOTAL = 4, step = 1, photos = [], items = [], sending = false, estim = null, libre = false;

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function val(n) { var e = form.elements[n]; return e && e.value ? String(e.value).trim() : ''; }
  function checked(n) { var e = form.querySelector('input[name="' + n + '"]:checked'); return e ? e.value : ''; }
  function collate(a, b) { return String(a).localeCompare(String(b), 'fr', { sensitivity: 'base' }); }
  function uniq(arr) { var seen = {}, out = []; arr.forEach(function (v) { var k = String(v || '').trim(); if (k && !seen[k]) { seen[k] = 1; out.push(k); } }); return out.sort(collate); }
  function fillSel(sel, values, placeholder) {
    sel.innerHTML = '';
    var o0 = document.createElement('option'); o0.value = ''; o0.textContent = placeholder; sel.appendChild(o0);
    values.forEach(function (v) { var o = document.createElement('option'); o.value = v; o.textContent = v; sel.appendChild(o); });
    sel.disabled = !values.length;
  }
  function reset(sel) { sel.innerHTML = '<option value="">—</option>'; sel.disabled = true; }
  function say(t) { if (note.firstChild) note.firstChild.textContent = t; }

  var idxPromise = null;
  function index() {
    if (idxPromise) return idxPromise;
    var api = window.LabelPriveSourcing;
    idxPromise = (api && api.load) ? api.load(['luxe', 'montres']).catch(function () { return []; }) : Promise.resolve([]);
    return idxPromise;
  }
  function pool() { return items.filter(function (it) { return it.v === cat.value; }); }

  cat.addEventListener('change', function () {
    reset(brand); reset(model); reset(version);
    if (!cat.value) { say('Commencez par choisir une catégorie. '); return; }
    say('Chargement du catalogue… ');
    index().then(function (all) {
      items = all;
      var names = uniq(pool().map(function (it) { return it.b; }));
      fillSel(brand, names, 'Sélectionnez');
      say(names.length ? 'Choisissez la maison, puis le modèle. ' : 'Catalogue indisponible : décrivez votre pièce. ');
      if (!names.length) startFree();
    });
  });
  brand.addEventListener('change', function () {
    reset(model); reset(version);
    if (!brand.value) return;
    var list = pool().filter(function (it) { return it.b === brand.value; });
    fillSel(model, uniq(list.map(function (it) { return it.m || it.t; })), 'Sélectionnez');
  });
  model.addEventListener('change', function () {
    reset(version);
    if (!model.value) return;
    var vers = uniq(pool().filter(function (it) { return it.b === brand.value && (it.m || it.t) === model.value; })
      .map(function (it) { return it.s || it.t; }));
    fillSel(version, vers, vers.length > 1 ? 'Sélectionnez' : '');
    if (vers.length === 1) version.value = vers[0];
  });
  function current() {
    var list = pool().filter(function (it) { return it.b === brand.value && (it.m || it.t) === model.value; });
    if (!list.length) return null;
    if (list.length === 1) return list[0];
    var hit = list.filter(function (it) { return (it.s || it.t) === version.value; });
    return hit[0] || null;
  }

  function univers() { return cat.value || 'luxe'; }
  function buildContext() {
    var u = univers();
    accWrap.innerHTML = (ACC[u] || []).map(function (a) {
      return '<label class="lp-choice"><input type="checkbox" name="accessoires" value="' + esc(a) + '"><span class="lp-choice__box"><span class="lp-choice__t">' + esc(a) + '</span></span></label>';
    }).join('');
    shotsUl.innerHTML = (SHOTS[u] || []).map(function (sh) { return '<li>' + esc(sh) + '</li>'; }).join('');
    refWrap.hidden = u !== 'montres';
    var it = libre ? null : current();
    if (it) {
      var mats = (it.mat || []).filter(Boolean);
      if (mats.length) { fillSel(matSel, mats, 'Sélectionnez'); matWrap.hidden = false; } else { matWrap.hidden = true; }
      var cols = (it.col || []).filter(Boolean);
      if (cols.length) { fillSel(colSel, cols, 'Sélectionnez'); colWrap.hidden = false; } else { colWrap.hidden = true; }
      recap.textContent = it.b + ' · ' + (it.t || it.m);
    } else {
      matWrap.hidden = true; colWrap.hidden = true;
      recap.textContent = TYPE[u] + ' · modèle à identifier';
    }
    freeWrap.hidden = !libre;
  }
  function open() {
    buildContext();
    section.hidden = false;
    show(1);
    card.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function startFree() { libre = true; open(); }
  freeBtn.addEventListener('click', startFree);
  start.addEventListener('click', function () {
    if (!cat.value) { say('Choisissez d’abord une catégorie. '); cat.focus(); return; }
    if (!brand.value || !model.value) { say('Choisissez une maison et un modèle, ou décrivez votre pièce. '); return; }
    if (!version.disabled && version.options.length > 2 && !version.value) { say('Choisissez la version ou la taille. '); return; }
    libre = false;
    open();
  });

  function resize(file) {
    return new Promise(function (res) {
      var fr = new FileReader();
      fr.onload = function () {
        var img = new Image();
        img.onload = function () {
          var w = img.width, h = img.height, max = CFG.largeur || 1600;
          if (w > max || h > max) { if (w > h) { h = Math.round(h * max / w); w = max; } else { w = Math.round(w * max / h); h = max; } }
          var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
          cv.getContext('2d').drawImage(img, 0, 0, w, h);
          res({ nom: file.name, data: cv.toDataURL('image/jpeg', 0.82) });
        };
        img.onerror = function () { res(null); };
        img.src = fr.result;
      };
      fr.onerror = function () { res(null); };
      fr.readAsDataURL(file);
    });
  }
  function renderThumbs() {
    thumbs.innerHTML = photos.map(function (p, i) {
      return '<div class="lpe__thumb"><img src="' + p.data + '" alt=""><button type="button" data-rm="' + i + '" aria-label="Retirer">×</button></div>';
    }).join('');
    photoCount.textContent = photos.length + ' photo' + (photos.length > 1 ? 's' : '') + ' ajoutée' + (photos.length > 1 ? 's' : '') + ' · ' + (CFG.photosMin || 4) + ' minimum';
    drop.querySelector('b').textContent = photos.length ? 'Ajouter d’autres photos' : 'Choisir mes photos';
  }
  thumbs.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rm]'); if (!b) return;
    photos.splice(parseInt(b.getAttribute('data-rm'), 10), 1); renderThumbs();
  });
  drop.addEventListener('click', function () { fileInp.click(); });
  drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInp.click(); } });
  fileInp.addEventListener('change', function () {
    var files = Array.prototype.slice.call(fileInp.files).slice(0, (CFG.photosMax || 10) - photos.length);
    if (!files.length) return;
    drop.querySelector('b').textContent = 'Préparation…';
    Promise.all(files.map(resize)).then(function (out) {
      out.filter(Boolean).forEach(function (p) { photos.push(p); });
      fileInp.value = '';
      renderThumbs();
    });
  });

  function computeEstim() {
    var it = libre ? null : current(), g = checked('etat');
    if (!it || !it.pe || !g) return null;
    var base = Number(it.pe[GRADE[g]] || 0);
    if (g === 'S' && it.pe[0]) base = Number(it.pe[0]) * ((CFG.coefS || 103) / 100);
    if (!base) return null;
    var bonus = 0;
    Array.prototype.forEach.call(form.querySelectorAll('input[name="accessoires"]:checked'), function (c) { bonus += (BONUS[c.value] || 0); });
    bonus = Math.min(bonus, CFG.bonusMax == null ? 8 : CFG.bonusMax);
    var marge = CFG.marge == null ? 10 : CFG.marge;
    var mid = base * (1 + bonus / 100);
    var pas = mid > 20000 ? 100 : 10;
    return { min: Math.round(mid * (1 - marge / 100) / pas) * pas, max: Math.round(mid * (1 + marge / 100) / pas) * pas,
             modele: it.t, grade: g, bonus: bonus };
  }
  function eur(n) { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n); }
  function renderRes() {
    estim = computeEstim();
    var delai = CFG.delai || '48 h ouvrées';
    if (!estim) {
      resBox.innerHTML = '<p class="lp-eyebrow">Estimation personnalisée</p>' +
        '<h2 class="lpe__q" style="margin-top:1.2rem">Votre pièce mérite un examen à la main</h2>' +
        '<p class="lpe__res-note">Nous n’avons pas assez de références comparables pour afficher une fourchette fiable tout de suite. Laissez-nous vos coordonnées : nous étudions vos photos et revenons vers vous sous ' + esc(delai) + ' avec une estimation argumentée.</p>';
      return;
    }
    var rachat = '';
    if (CFG.showRachat) {
      var taux = CFG.tauxRachat || 55;
      var rl = Math.round(estim.min * taux / 100 / 10) * 10, rh = Math.round(estim.max * taux / 100 / 10) * 10;
      rachat = '<p class="lpe__recap">Rachat immédiat, à titre indicatif : ' + esc(eur(rl)) + ' à ' + esc(eur(rh)) + '. Montant confirmé après examen de la pièce.</p>';
    }
    resBox.innerHTML = '<p class="lp-eyebrow">Votre estimation</p>' +
      '<p class="lpe__recap" style="margin:0">' + esc(estim.modele) + ' · ' + esc(GRADE_LABEL[estim.grade]) + '</p>' +
      '<div class="lpe__res-val">' + esc(eur(estim.min)) + ' – ' + esc(eur(estim.max)) + '</div>' +
      '<p class="lpe__res-note">Fourchette constatée sur le marché de l’occasion pour ce modèle dans l’état que vous avez déclaré' + (estim.bonus ? ', accessoires inclus' : '') + '. Ce n’est pas une offre de rachat : notre proposition vous est adressée sous ' + esc(delai) + ', après examen de vos photos.</p>' + rachat;
  }

  function pane(n) { return root.querySelector('[data-lpe-pane="' + n + '"]'); }
  function show(n) {
    for (var i = 1; i <= TOTAL; i++) pane(i).hidden = (i !== n);
    step = n;
    bar.hidden = false;
    fillEl.style.width = Math.round(n / TOTAL * 100) + '%';
    count.textContent = 'Étape ' + n + ' / ' + TOTAL;
    next.textContent = n === TOTAL ? 'Envoyer ma demande' : 'Continuer';
    err.textContent = '';
    if (n > 1) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  root.addEventListener('click', function (e) {
    if (!e.target.closest('[data-lpe-back]')) return;
    show(Math.max(1, step - 1));
  });

  function validate() {
    var minPhotos = CFG.photosMin || 4;
    if (step === 1) {
      if (libre && !val('modele_libre')) return 'Décrivez votre pièce en une ligne.';
      if (!checked('etat')) return 'Indiquez l’état de votre pièce.';
    }
    if (step === 2 && photos.length < minPhotos) return 'Ajoutez au moins ' + minPhotos + ' photos : sans elles, l’estimation ne peut pas être fiable.';
    if (step === 3 && !checked('souhait')) return 'Indiquez ce que vous souhaitez faire.';
    if (step === 4) {
      if (!val('prenom') || !val('nom') || !val('email')) return 'Merci de compléter prénom, nom et e-mail.';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val('email'))) return 'Adresse e-mail invalide.';
      if (!form.elements['consentement'].checked) return 'Merci d’accepter d’être contacté(e) pour recevoir votre estimation.';
    }
    return '';
  }

  function fallbackId() {
    var d = new Date(), p = function (n) { return (n < 10 ? '0' : '') + n; };
    return 'LP-ESTIM-W' + String(d.getFullYear()).slice(2) + p(d.getMonth() + 1) + p(d.getDate()) + p(d.getHours()) + p(d.getMinutes()) + p(d.getSeconds());
  }
  function accessoires() {
    return Array.prototype.map.call(form.querySelectorAll('input[name="accessoires"]:checked'), function (c) { return c.value; }).join(', ');
  }
  function payload() {
    var it = libre ? null : current();
    return {
      source: 'site-estimation', page_url: location.href.split('?')[0],
      type: TYPE[univers()], univers: univers(),
      marque: libre ? 'À identifier' : brand.value,
      modele: libre ? val('modele_libre') : model.value,
      sous_modele: libre ? '' : version.value,
      handle: it ? it.h : '', reference: val('reference'),
      taille: it ? (it.z || '') : '', matiere: matWrap.hidden ? '' : matSel.value, couleur: colWrap.hidden ? '' : colSel.value,
      annee: val('annee'), etat: checked('etat'), etat_libelle: GRADE_LABEL[checked('etat')] || '',
      accessoires: accessoires(), defauts: val('defauts'),
      estimation_min: estim ? estim.min : '', estimation_max: estim ? estim.max : '',
      souhait: checked('souhait'), statut: 'Nouvelle demande',
      prenom: val('prenom'), nom: val('nom'), email: val('email'), telephone: val('telephone'), ville: val('ville'),
      consentement: form.elements['consentement'].checked ? 'oui' : 'non',
      newsletter: form.elements['newsletter'].checked ? 'oui' : 'non',
      photos: photos
    };
  }
  function textSummary(p) {
    return ['DEMANDE D’ESTIMATION ' + (p.id || ''), '', p.type, p.marque + ' — ' + p.modele + (p.sous_modele ? ' / ' + p.sous_modele : ''),
      'Référence : ' + (p.reference || '—'), 'Matière : ' + (p.matiere || '—') + ' · Coloris : ' + (p.couleur || '—'),
      'Année : ' + (p.annee || '—'), 'État déclaré : ' + p.etat_libelle, 'Accessoires : ' + (p.accessoires || '—'),
      'Défauts signalés : ' + (p.defauts || '—'),
      'Estimation affichée : ' + (p.estimation_min ? p.estimation_min + ' à ' + p.estimation_max + ' €' : 'estimation manuelle'),
      'Souhait : ' + p.souhait, '', 'Client : ' + p.prenom + ' ' + p.nom, 'Tél : ' + (p.telephone || '—'), 'Ville : ' + (p.ville || '—'),
      'Consentement : ' + p.consentement + ' · Newsletter : ' + p.newsletter, '',
      p.photos.length + ' photo(s) prises par le client — non transmises par ce canal : demandez-les par retour d’e-mail.'].join('\n');
  }
  function viaContactForm(p, redirect) {
    var cf = document.getElementById('lpe-contact-form');
    if (!cf) return false;
    cf.querySelector('[name="contact[email]"]').value = p.email;
    cf.querySelector('[name="contact[name]"]').value = p.prenom + ' ' + p.nom;
    cf.querySelector('[name="contact[phone]"]').value = p.telephone;
    cf.querySelector('[name="contact[body]"]').value = textSummary(p);
    if (redirect) {
      sessionStorage.setItem('lpe-pending', '1');
      sessionStorage.setItem('lpe-id', p.id || '');
      sessionStorage.setItem('lpe-prenom', p.prenom);
      cf.submit(); return true;
    }
    fetch(cf.action, { method: 'POST', body: new FormData(cf), credentials: 'same-origin' }).catch(function () {});
    return true;
  }
  function done(id, prenom) {
    card.innerHTML = '<div class="lp-done"><p class="lp-eyebrow">Demande enregistrée</p>' +
      '<h2 class="lp-h2">Merci ' + esc(prenom) + ', votre dossier est ouvert.</h2>' +
      '<div class="lpe__id">' + esc(id) + '</div>' +
      '<p class="lp-lead">Nous examinons vos photos et revenons vers vous sous ' + esc(CFG.delai || '48 h ouvrées') + '. Conservez ce numéro : il suit votre dossier jusqu’au règlement.</p>' +
      '<p style="margin-top:2.8rem"><a class="lp-btn lp-btn--ghost" href="' + esc(CFG.catalogueUrl || '/pages/sourcing-luxe') + '">Découvrir le catalogue Label Privé</a></p></div>';
    bar.hidden = true;
    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (window.dataLayer) window.dataLayer.push({ event: 'estimation_request', estimation_id: id });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (sending) return;
    var msg = validate();
    if (msg) { err.textContent = msg; return; }
    err.textContent = '';
    if (step === 2) { renderRes(); show(3); return; }
    if (step < TOTAL) { show(step + 1); return; }

    sending = true;
    next.innerHTML = '<span class="lp-spinner"></span>';
    var p = payload();
    if (!CFG.endpoint) { p.id = fallbackId(); viaContactForm(p, true); return; }
    fetch(CFG.endpoint, { method: 'POST', body: JSON.stringify(p), redirect: 'follow' })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.ok && res.id) {
          p.id = res.id;
          if (CFG.alwaysEmail) viaContactForm(p, false);
          sending = false; done(res.id, p.prenom);
        } else throw new Error((res && res.error) || 'Erreur');
      })
      .catch(function (e2) {
        console.warn('[Estimation]', e2);
        p.id = fallbackId(); viaContactForm(p, true);
      });
  });

  if (/contact_posted=true/.test(location.search) && sessionStorage.getItem('lpe-pending')) {
    sessionStorage.removeItem('lpe-pending');
    section.hidden = false;
    done(sessionStorage.getItem('lpe-id') || '', sessionStorage.getItem('lpe-prenom') || '');
  }
})();
